import request from "@/api/request";

export function loadLocale() {
    return request({
        url: `/locale`,
        method: 'get',
    });
}
